import { connect } from 'react-redux';
import ToDeposit from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(ToDeposit);
